import React from 'react';
import styled from 'styled-components';
import { Sparkles } from 'lucide-react';
import colors from 'theme/colors';
import { panelAccent, panelAccentAlpha } from 'theme/panelAccent';

const ACCENT_COLOR = panelAccent(colors.secondaryPurple);
const ACCENT_SOFT = panelAccentAlpha(colors.secondaryPurple, '12');

/**
 * Linha "Inserir variável: [Nome] [Ingresso]" que fica junto de um campo de
 * texto. Cada botão entrega ao pai o token pronto (`{{nome}}`), que ele insere
 * onde estiver o cursor — o editor e o campo simples guardam o cursor de jeitos
 * diferentes, então quem insere é quem conhece o campo.
 *
 * Usado nas campanhas de e-mail e no recado do ingresso.
 *
 * `variables`: `[{ key: 'nome', label: 'Nome' }]`
 */
export default function VariableChips({ variables, onInsert }) {
    if (!variables?.length) return null;

    return (
        <Row>
            <Label>
                <Sparkles size={12} strokeWidth={2.2} />
                Inserir variável:
            </Label>
            {variables.map(variable => (
                <Chip
                    key={variable.key}
                    type='button'
                    onClick={() => onInsert(`{{${variable.key}}}`)}
                >
                    {variable.label}
                </Chip>
            ))}
        </Row>
    );
}

const Row = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
`;

const Label = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-weight: 600;
    color: ${colors.nightLight};
    margin-right: 2px;
`;

const Chip = styled.button`
    padding: 3px 9px;
    border-radius: 20px;
    border: 1px solid ${ACCENT_COLOR};
    background: ${ACCENT_SOFT};
    color: ${ACCENT_COLOR};
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;

    &:hover {
        background: ${panelAccentAlpha(colors.secondaryPurple, '20')};
    }
`;
